import React from 'react';
import { useTranslation } from 'react-i18next';

import { withFirebase } from '../Firebase';


const SignOutButton = ({ firebase }) => {
  const { t } = useTranslation();
  return (
    <a style={{ margin: 0 }} role='button' className='outline contrast' onClick={firebase.doSignOut}>{t('signOut.button_text')}</a>
  );
};

export default withFirebase(SignOutButton);
